export const GLOBAL_STATE = 'Student'

export const STUDENT = 'STUDENT' as const
export const STUDENT_STATUS_UPDATE = 'STUDENT_STATUS_UPDATE' as const
export const STUDENT_DELETE = 'STUDENT_DELETE' as const
export const STUDENT_LIST = 'STUDENT_LIST' as const
export const STUDENT_ALL = 'STUDENT_ALL' as const
export const STUDENT_GUARD_CREATE = 'STUDENT_GUARD_CREATE' as const
export const STUDENT_GUARD_LIST = 'STUDENT_GUARD_LIST' as const
export const STUDENT_USERNAME = 'STUDENT_USERNAME' as const
export const STUDENT_PERSONAL_INFO = 'STUDENT_PERSONAL_INFO' as const
export const STUDENT_CONTACT_INFO = 'STUDENT_CONTACT_INFO' as const
export const STUDENT_ACCOUNT_INFO = 'STUDENT_ACCOUNT_INFO' as const
export const STUDENT_ACCOUNT_INFO_WITH_DELETED = 'STUDENT_ACCOUNT_INFO_WITH_DELETED' as const
export const STUDENT_FULL_INFO = 'STUDENT_FULL_INFO' as const
export const GENERATE_TRANSCRIPT = 'GENERATE_TRANSCRIPT' as const
export const GENERATE_PROOF_OF_STUDY = 'GENERATE_PROOF_OF_STUDY' as const
export const STUDENT_ACHIEVEMENT_RECORDS = 'STUDENT_ACHIEVEMENT_RECORDS' as const
export const STUDENT_PUBLIC_TRANSCRIPT = 'STUDENT_PUBLIC_TRANSCRIPT' as const
export const STUDENT_PUBLIC_STUDY_PROOF = 'STUDENT_PUBLIC_STUDY_PROOF' as const
export const STUDENT_STUDY_PROOF_GENERATE = 'STUDENT_STUDY_PROOF_GENERATE' as const
